<template>
  <div
    class="cec-select-search position-relative"
    :class="{ 'is-invalid': state === false }"
  >
    <!-- Wrapper do input + ícone -->
    <div class="cec-select-search-input-wrapper">
      <input
        ref="input"
        type="text"
        :class="['form-control', inputStateClass, inputClass]"
        :style="inputStyle"
        :placeholder="placeholder"
        :disabled="disabled"
        v-model="search"
        @input="onSearchInput"
        @focus="onFocus"
        @blur="onBlur"
        @keydown.down.prevent="onArrowDown"
        @keydown.up.prevent="onArrowUp"
        @keydown.enter.prevent="onEnter"
        @keydown.esc.prevent="onEsc"
      />

      <!-- Ícone de seta, alternando up/down -->
      <span
        class="cec-select-caret fa"
        :class="isOpen && filteredOptions.length > 0 ? 'fa-caret-up' : 'fa-caret-down'"
        @mousedown.prevent="onToggleOpen"
      ></span>

      <!-- Botão limpar (X) -->
      <img
        v-show="!disabled && search"
        class="cec-select-clear"
        :src="'../../../static/img/close.svg'"
        @mousedown.prevent="onClear"
      />
    </div>

    <!-- Dropdown de opções -->
    <ul
      v-if="isOpen"
      class="dropdown-menu show mt-0"
      :class="{ 'dropup-menu': dropup }"
      style="max-height: 250px; overflow-y: auto;"
    >
      <li
        v-if="filteredOptions.length === 0"
        class="dropdown-item disabled text-muted"
      >
        {{ noOptionsText }}
      </li>

      <li
        v-for="(option, index) in filteredOptions"
        :key="String(option.value) + '_' + index"
        class="dropdown-item"
        :class="{
          active: index === highlightedIndex,
          disabled: option.disabled
        }"
        @mousedown.prevent="onOptionClick(option)"
      >
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: 'CecSelectSearch',
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array, null],
      default: null
    },
    options: {
      type: Array,
      default: function () {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Selecione...'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noOptionsText: {
      type: String,
      default: 'Nenhuma opção encontrada'
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    caseInsensitive: {
      type: Boolean,
      default: true
    },
    dropup: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: [String, Object, Array],
      default: ''
    },
    inputStyle: {
      type: [String, Object, Array],
      default: ''
    }
  },
  data: function () {
    return {
      isOpen: false,
      search: '',
      highlightedIndex: -1
    };
  },
  computed: {
    normalizedOptions: function () {
      return this.options.map(function (opt) {
        if (
          typeof opt === 'string' ||
          typeof opt === 'number' ||
          typeof opt === 'boolean'
        ) {
          return { value: opt, text: String(opt), disabled: false };
        }
        return {
          value: opt.value,
          text: opt.text != null ? opt.text : String(opt.value),
          disabled: !!opt.disabled
        };
      });
    },
    filteredOptions: function () {
      var list = this.normalizedOptions;
      var term = this.search || '';

      if (!term) {
        return list;
      }

      if (this.caseInsensitive) {
        term = term.toString().toLowerCase();
        return list.filter(function (opt) {
          return opt.text.toString().toLowerCase().indexOf(term) !== -1;
        });
      }

      return list.filter(function (opt) {
        return opt.text.toString().indexOf(term) !== -1;
      });
    },
    inputStateClass: function () {
      if (this.state === true) {
        return 'is-valid';
      }
      if (this.state === false) {
        return 'is-invalid';
      }
      return '';
    },
    selectedLabel: function () {
      var val = this.value;
      var opt = this.normalizedOptions.find(function (o) {
        return o.value === val;
      });
      return opt ? opt.text : '';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newVal) {
        this.syncInputWithValue(newVal);
        this.$emit('update:label', this.selectedLabel);
        this.$emit('selected-label', this.selectedLabel);
      }
    },
    options: function () {
      this.syncInputWithValue(this.value);
    }
  },
  mounted: function () {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    syncInputWithValue: function (val) {
      var opt = this.normalizedOptions.find(function (o) {
        return o.value === val;
      });
      this.search = opt ? opt.text : '';
    },
    handleClickOutside: function (evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
      }
    },
    onToggleOpen: function () {
      if (this.disabled) {
        return;
      }
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        var self = this;
        this.$nextTick(function () {
          if (self.$refs.input) {
            self.$refs.input.focus();

            var idx = self.filteredOptions.findIndex(function (o) {
              return o.value === self.value;
            });
            self.highlightedIndex =
              idx >= 0 ? idx : self.filteredOptions.length > 0 ? 0 : -1;
          }
        });
      }
    },
    onFocus: function () {
      if (!this.isOpen && !this.disabled) {
        this.isOpen = true;
      }
    },

    // >>> AQUI O PONTO PRINCIPAL <<<
    onBlur: function () {
      // sempre que sair do campo:
      this.isOpen = false;
      this.highlightedIndex = -1;
      this.validateOrClear();
    },

    validateOrClear: function () {
      var txt = (this.search || '').trim();
      var opt;

      if (!txt) {
        if (this.value !== null) {
          this.$emit('input', null);
          this.$emit('change', null);
        }
        this.search = '';
        return;
      }

      // match exato
      opt = this.normalizedOptions.find(function (o) {
        return o.text === txt;
      });

      // match exato case-insensitive
      if (!opt) {
        var lower = txt.toLowerCase();
        opt = this.normalizedOptions.find(function (o) {
          return (
            o.text &&
            o.text.toString().toLowerCase() === lower
          );
        });
      }

      if (opt) {
        if (opt.value !== this.value) {
          this.$emit('input', opt.value);
          this.$emit('change', opt.value);
        }
        this.search = opt.text;
      } else {
        // texto não existe na lista -> zera
        if (this.value !== null) {
          this.$emit('input', null);
          this.$emit('change', null);
        }
        this.search = '';
      }
    },

    onSearchInput: function () {
      if (!this.isOpen) {
        this.isOpen = true;
      }
      this.highlightedIndex = this.filteredOptions.length > 0 ? 0 : -1;
    },
    onArrowDown: function () {
      if (!this.isOpen) {
        this.isOpen = true;
      }
      var len = this.filteredOptions.length;
      if (len === 0) {
        return;
      }
      if (this.highlightedIndex < len - 1) {
        this.highlightedIndex++;
      } else {
        this.highlightedIndex = 0;
      }
    },
    onArrowUp: function () {
      if (!this.isOpen) {
        this.isOpen = true;
      }
      var len = this.filteredOptions.length;
      if (len === 0) {
        return;
      }
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      } else {
        this.highlightedIndex = len - 1;
      }
    },
    onEnter: function () {
      if (!this.isOpen) {
        return;
      }
      if (
        this.highlightedIndex < 0 ||
        this.highlightedIndex >= this.filteredOptions.length
      ) {
        return;
      }
      var opt = this.filteredOptions[this.highlightedIndex];
      if (opt && !opt.disabled) {
        this.selectOption(opt);
      }
    },
    onEsc: function () {
      this.isOpen = false;
      this.highlightedIndex = -1;
      this.syncInputWithValue(this.value);
    },
    onOptionClick: function (opt) {
      if (opt.disabled) {
        return;
      }
      this.selectOption(opt);
      // força blur pra fechar tudo e garantir estado
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    selectOption: function (opt) {
      this.$emit('input', opt.value);
      this.$emit('change', opt.value);
      this.search = opt.text;
      this.isOpen = false;
      this.highlightedIndex = -1;
    },
    onClear: function () {
      this.search = '';
      this.$emit('input', null);
      this.$emit('change', null);
      this.isOpen = false;
      this.highlightedIndex = -1;
      // Garante foco de volta no input
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    }
  }
};
</script>


<style scoped>
.cec-select-search {
  width: 100%;
}

/* Wrapper para conseguir posicionar o ícone dentro do input */
.cec-select-search-input-wrapper {
  position: relative;
  width: 100%;
}

/* mesma altura dos outros campos da tela (ajuste se precisar) */
.cec-select-search .form-control {
  height: 32px;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  padding-right: 3rem; /* espaço para ícone de validação + caret */
}

.cec-select-search .form-control::placeholder {
  color: inherit;
  opacity: 1 !important;
}

.cec-select-search .form-control:placeholder-shown {
  font-weight: normal;
}

/* faz o input se comportar como o select quanto ao ícone de validação */
/* faz o input se comportar como o select quanto ao ícone de validação */
.cec-select-search .form-control.is-invalid,
.cec-select-search .form-control.is-valid {
  /* Aumenta padding quando tem validação para caber o ícone de validação + botão clear + seta */
  padding-right: 4.5rem !important;
  background-position: right 2.7rem center !important;
}

/* Ajuste do botão clear quando o input tem validação (move mais para a esquerda) */
.cec-select-search .form-control.is-invalid ~ .cec-select-clear,
.cec-select-search .form-control.is-valid ~ .cec-select-clear {
  right: 1.5rem;
}

/* Ícone da seta dentro do input */
.cec-select-caret {
  position: absolute;
  right: 0.4rem;        /* bem na borda direita */
  top: 50%;
  transform: translateY(-50%);
  pointer-events: auto;
  cursor: pointer;
  color: #6c757d;
  font-size: 0.9rem;
}

/* Botão de limpar (X) */
.cec-select-clear {
  position: absolute;
  right: 1.5rem; /* Padrão (sem validação): ao lado da seta */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 14px;
  height: 14px;
  z-index: 10;
}

/* Dropdown ocupando a mesma largura do campo */
.cec-select-search .dropdown-menu {
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 0; /* encostado no campo */
}

.cec-select-search .dropdown-menu.dropup-menu {
  top: auto;
  bottom: 100%;
  margin-bottom: 0.125rem;
}

/* Itens mais compactos e sem linhas entre eles */
.cec-select-search .dropdown-item {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  border-bottom: none;
  font-weight: normal;
  color: #212529 !important;
}

.cec-select-search li {
  border-bottom: none;
  
}

.cec-select-search .dropdown-item:hover {
  background-color: #d9f4ff !important;
  
}

/* cor da seleção (azul do seu tema) */
.cec-select-search .dropdown-item.active,
.cec-select-search .dropdown-item.active:focus,
.cec-select-search .dropdown-item.active:hover {
  background-color: #d9f4ff !important;
  color: #000000;
}


</style>



// WEBPACK FOOTER //
// src/views/componentes/dropdown/CecSelectSearch.vue